// extracted by mini-css-extract-plugin
export default {"fondoOscuro":"Acordeon_fondoOscuro__39RAl","imagen-blanca":"Acordeon_imagen-blanca__-OTtX","acordeonBtn":"Acordeon_acordeonBtn__Igu5K","acordeon":"Acordeon_acordeon__BUYiC"};